import { HttpParams } from '@angular/common/http'
import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjChartModule } from '@grapecity/wijmo.angular2.chart'
import { WjChartAnnotationModule } from '@grapecity/wijmo.angular2.chart.annotation'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType, Grid, ListItem, ModalSize, RetentionMitigation } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { SafetyMitigationComponent } from '../safety/safety-mitigation.component'

@Component({
    templateUrl: './retention.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavContent,
        FormsModule,
        WjInputModule,
        WjChartModule,
        AutoSizeDirective,
        WjChartAnnotationModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        NgbNavOutlet,
    ],
})
export class RetentionComponent extends BaseComponent {
    faSearch = faSearch
    active = 1
    timeSeries: any[] = []
    otherSeries: any[] = []
    masterData: any[] = []
    otherSeriesNames: any[] = []
    mitigationGrid: Grid<RetentionMitigation>
    timeunits: ListItem<number>[] = []
    selectedTimeunit = 5
    stackingOptions = [
        new ListItem(0, 'No Stacking'),
        new ListItem(1, 'Stack By PR Department'),
        new ListItem(2, 'Stack By Position Code'),
        new ListItem(3, 'Stack By PR Dept and PC'),
    ]
    selectedStackOption = 0

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.HrRetentionEdit])
    }

    constructor() {
        super()
        this.mitigationGrid = new Grid<RetentionMitigation>(this.services)
            .setupModalEditing(
                this.services.data.retentionMitigations,
                'Retention Event',
                SafetyMitigationComponent,
                () => new RetentionMitigation(),
                this,
                ModalSize.medium,
            )
            .filterBy(item => [item.description, item.chartLabel])

        this.timeunits.push(new ListItem(5, 'Monthly'))
        this.timeunits.push(new ListItem(6, 'Quarterly'))
        this.timeunits.push(new ListItem(7, 'Yearly'))
    }

    public refresh() {
        const params = new HttpParams().set('stackOption', this.selectedStackOption)
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get('api/Retention/GetRetentionData', params),
                    this.services.data.retentionMitigations.queryAll(),
                )
                .subscribe({
                    next: successResult => {
                        this.initialLoadingComplete()
                        this.timeSeries = successResult[0].baseSeries.data
                        this.otherSeries = successResult[0].chartSeries

                        const masterData = [] as any[]
                        const otherSeriesNames = [] as string[]
                        for (const serie of this.otherSeries.orderBy(x => x.name)) {
                            const name = serie.name
                            otherSeriesNames.push(name)
                            for (const d of serie.data) {
                                let match = masterData.find(x => x.formattedDate === d.formattedDate)
                                if (match === undefined) {
                                    match = {}
                                    match.formattedDate = d.formattedDate
                                    match[name] = d.retentionRatio
                                    masterData.push(match)
                                } else {
                                    match[name] = d.retentionRatio
                                }
                            }
                        }
                        for (const d of this.timeSeries) {
                            const match = masterData.find(x => x.formattedDate === d.formattedDate)
                            match['Retention'] = d.retentionRatio
                        }

                        this.masterData = masterData
                        this.otherSeriesNames = otherSeriesNames
                        if (this.selectedStackOption == 0) {
                            this.otherSeriesNames = []
                        }

                        this.mitigationGrid.items = successResult[1]
                        this.processAnnotationLocation()
                    },
                }),
        )
    }

    processAnnotationLocation() {
        for (const item of this.services.data.retentionMitigations.items) {
            let match
            switch (this.selectedTimeunit) {
                case 5:
                    match = this.timeSeries.find(x => x.formattedDate === item.dateLabelMonth)
                    break
                case 6:
                    match = this.timeSeries.find(x => x.formattedDate === item.dateLabelQuarter)
                    break
                case 7:
                    match = this.timeSeries.find(x => x.formattedDate === item.dateLabelYear)
                    break
                default:
            }
            if (match) item.pointIndex = this.timeSeries.indexOf(match)
        }
    }

    tabChanged() {
        setTimeout(() => {
            this.processAnnotationLocation()
            window.dispatchEvent(new Event('resize'))
        }, 100)
    }
}
